// @flow
import { handleActions } from 'redux-actions';
import { fromJS, Map as ImmutableMap } from 'immutable';
import handleReduce from '~/core/state/handle-reduce';

import {
    LEAK_SENSOR_SET_CURRENT_DAY,
    LEAK_SENSOR_PAGE_READY,
    LEAK_SENSOR_RECEIVE_EVENTS,
    LEAK_SENSOR_LOAD_SELECTED_DAY_EVENTS
} from './constants';

const initialState = ImmutableMap();

export const actionHandler = {
    [LEAK_SENSOR_LOAD_SELECTED_DAY_EVENTS]: handleReduce((state, { payload: { id } }) =>
        state.setIn([id, 'hasLoaded'], false)
    ),
    [LEAK_SENSOR_PAGE_READY]: handleReduce((state, { payload: { id } }) => state.setIn([id, 'hasLoaded'], true)),
    [LEAK_SENSOR_RECEIVE_EVENTS]: handleReduce((state, { payload: { data, day, id } }) =>
        state.withMutations(tempState =>
            tempState.setIn([id, 'events', day], fromJS(data)).setIn([id, 'hasLoaded'], true)
        )
    ),
    [LEAK_SENSOR_SET_CURRENT_DAY]: handleReduce((state, { payload: { id, day } }) =>
        state.setIn([id, 'eventsCurrentDay'], day)
    )
};

export default handleActions(actionHandler, initialState);



// WEBPACK FOOTER //
// ./src/core/state/products/leak-sensor/index.js